const appid: string = 'dwnh274KQnv6iNPZfqeSjchO5KfRyIIG'
const apiUrl: string = `https://grip.gimnechiske.org/API/RSPLUS.php?appid=${appid}`;
// const apiUrl: string = `https://grip.gimnechiske.org/API/RSPLUS.php`;

export default apiUrl;
